import React from 'react'
import { Box, Checkbox, Paper, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { styled } from '@mui/system'
import { useGlobalState } from 'state'
import { LAYERS } from 'common/layers'

const LegendTypography = styled(Typography)({
  fontSize: 11,
  color: grey[700],
  fontWeight: 'bold',
  whiteSpace: 'pre-line',
})

const LegendCheckbox = styled(Checkbox)({
  padding: 0,
})

export const EstimatedFloodingLegendControl = () => {
  const { app } = useGlobalState()
  const { estimatedFloodingLayers, setEstimatedFloodingLayers } = app

  const [layers, setLayers] = React.useState<{[key: string]: boolean}>(() => {
    return {
      [LAYERS.SCHOOL_AREA_RISK.id]: estimatedFloodingLayers.includes(LAYERS.SCHOOL_AREA_RISK.id),
      [LAYERS.RIVER.id]: estimatedFloodingLayers.includes(LAYERS.RIVER.id),
      [LAYERS.EF_SHINSUISOUTEI.id]: estimatedFloodingLayers.includes(LAYERS.EF_SHINSUISOUTEI.id),
      [LAYERS.EF_SHINSUISOUTEI_COLOR.id]: estimatedFloodingLayers.includes(LAYERS.EF_SHINSUISOUTEI_COLOR.id),
      // [LAYERS.EF_TOKUNICHUUI.id]: estimatedFloodingLayers.includes(LAYERS.EF_TOKUNICHUUI.id),
      [LAYERS.EF_SHINSUILATEST.id]: false,
    }
  })

  const changeVisibleLayer = (layerId: string, visible: boolean) => {
    const value = {...layers, [layerId]: visible}
    setLayers(value)

    const arr = [...estimatedFloodingLayers]
    const idx = arr.indexOf(layerId)
    if (arr.indexOf(layerId) >= 0 && !visible) {
      arr.splice(idx, 1)
    } else if (arr.indexOf(layerId) < 0 && visible) {
      arr.push(layerId)
    }
    setEstimatedFloodingLayers(arr)
  }

  return (
    <Stack direction={'column'} alignItems={'flex-start'} spacing={1} minWidth={150}>

      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <LegendCheckbox size='small' checked={layers[LAYERS.SCHOOL_AREA_RISK.id]} onChange={(e) => changeVisibleLayer(LAYERS.SCHOOL_AREA_RISK.id, e.target.checked)} />
        <Box sx={{ width: 20, height: '1px', borderBottom: '3px solid #f44336' }}></Box>
        <LegendTypography>避難対象地区</LegendTypography>
      </Stack>

      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <LegendCheckbox size='small' checked={layers[LAYERS.RIVER.id]} onChange={(e) => changeVisibleLayer(LAYERS.RIVER.id, e.target.checked)} />
        <Box sx={{ width: 20, height: '1px', borderBottom: '3px solid #0000ff' }}></Box>
        <LegendTypography>河川</LegendTypography>
      </Stack>

      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <LegendCheckbox size='small' checked={layers[LAYERS.EF_SHINSUISOUTEI.id]} onChange={(e) => changeVisibleLayer(LAYERS.EF_SHINSUISOUTEI.id, e.target.checked)} />
        <Paper sx={{ width: 14, height: 12, backgroundColor: grey[300]}} square variant='outlined'></Paper>
        <LegendTypography>{'洪水浸水想定区域\n(灰色)'}</LegendTypography>
      </Stack>

      { false && <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <LegendCheckbox size='small' checked={layers[LAYERS.EF_TOKUNICHUUI.id]} onChange={(e) => changeVisibleLayer(LAYERS.EF_TOKUNICHUUI.id, e.target.checked)} />
        <Paper sx={{ width: 14, height: 12, backgroundColor: grey[500]}} square variant='outlined'></Paper>
        <LegendTypography>{'特に注意が必要と\n見込まれる区域'}</LegendTypography>
      </Stack> }

      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <LegendCheckbox size='small' checked={layers[LAYERS.EF_SHINSUISOUTEI_COLOR.id]} onChange={(e) => changeVisibleLayer(LAYERS.EF_SHINSUISOUTEI_COLOR.id, e.target.checked)} />
        <Paper sx={{ width: 14, height: 12, backgroundColor: 'rgb(255, 183, 183)'}} square variant='outlined'></Paper>
        <LegendTypography>洪水浸水想定区域</LegendTypography>
      </Stack>
    </Stack>
  )
}
